import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Breadcrumb,
} from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addPrescription } from "../../../actions/refillPrescriptionAction";
import { getPartnersDiscountActive } from "../../../actions/partnerDiscountAction";
import FullPageLoader from "../../../components/FullPageLoader/FullPageLoader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";

// Schema for yup
const validationSchema = Yup.object().shape({
  title: Yup.string()
    .min(2, "Title must have at least 2 characters")
    .max(100, "Title can't be longer than 100 characters")
    .trim("Spaces are not allowed")
    .required("Title is required"),
  shortDescription: Yup.string()
    .trim()
    .required("Short description field is required"),
  price: Yup.number().required("Price field is required").positive(),
  minAge: Yup.number()
    .required("Minimum age field is required")
    .positive()
    .min(18, "Ming age must be 18 or greater"),
  discount: Yup.number()
    .required("Discount field is required")
    .min(0, "discount must be zero or greater"),
  photo: Yup.string().required("Photo field is required"),
  description: Yup.string().required("Description field is required"),
});

const AddPrescriptionRefill = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [partnerDiscountData, setPartnerDiscountData] = useState([]);
  const [getFile, setFile] = useState("");
  const [uploadImage, setUploadImage] = useState(false);
  const formik = useFormik({
    initialValues: {
      title: "",
      shortDescription: "",
      photo: "",
      price: "",
      discount: "",
      minAge: "",
      description: "",
      status: false,
      partnerDiscountType: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("title", values.title);
      formData.append("shortDescription", values.shortDescription);
      formData.append("discount", values.discount);
      formData.append("minAge", values.minAge);
      formData.append("description", values.description);
      formData.append("status", values.status);
      formData.append("price", values.price);
      formData.append("photo", values.photo);
      formData.append("partnerDiscountType", values.partnerDiscountType);
      setLoader(true);
      // When button submits form and form is in the process of submitting, submit button is disabled
      let res = await addPrescription(formData);
      setLoader(false);
      if (res.data.success) {
        navigate("/forms/prescription-refill");
        toast.success(res.data.message);
      }
    },
  });
  const getAllPartnerDiscount = async () => {
    setLoader(true);
    let res = await getPartnersDiscountActive();
    if (res?.data?.data?.partners) {
      setPartnerDiscountData(res?.data?.data?.partners);
    }
    setLoader(false);
  };
  const handlePreviewImage = (e, setFieldValue) => {
    if (e.target.files[0].type.split("/")[1]) {
      let imageType = e.target.files[0].type.split("/")[1];
      if (
        imageType === "png" ||
        imageType === "jpg" ||
        imageType === "jpeg" ||
        imageType === "gif" ||
        imageType === "webp"
      ) {
        setFieldValue("photo", e.target.files[0]);
        setFile(URL.createObjectURL(e.target.files[0]));
      } else {
        setUploadImage(true);
        e.target.value = null;
      }
    }
  };
  const hideModel = () => {
    setUploadImage(false);
  };
  const onEditorChange = async (event, editor, setFieldValue) => {
    setFieldValue("description", editor.getData());
  };

  useEffect(() => {
    getAllPartnerDiscount();
  }, []);
  return (
    <>
      {uploadImage ? (
        <SweetAlert
          warning
          showCloseButton
          confirmBtnText="OK"
          onConfirm={hideModel}
          confirmBtnBsStyle="danger"
          title="Failed! Please select correct Image Format"
          onCancel={hideModel}
          focusCancelBtn
          customClass="del-sweet-alert "
        >
          Supported files ["png", "jpg", "jpeg", "gif", "webp"]
        </SweetAlert>
      ) : null}
      {loader ? (
        <FullPageLoader />
      ) : (
        <div className="pt-2 pt-md-3 cms-updated-style">
          <Container fluid>
            <Row>
              <Col md="12">
                {/* <Breadcrumb className="care-md-breadcrumb">
                  <Link
                    className="breadcrumb-item"
                    to="/forms/prescription-refill"
                  >
                    Prescription Refill
                  </Link>
                  <Breadcrumb.Item active>Add</Breadcrumb.Item>
                </Breadcrumb> */}
                <Card className="filter-card card">
                  <Card.Header>
                    <div className="d-flex align-items-center justify-content-between table-head">
                      <Card.Title className="text-white" as="h4">
                        Add Content
                      </Card.Title>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Form onSubmit={formik.handleSubmit}>
                          <Form.Group
                            className="mb-3"
                            controlId="formBasicTitle"
                          >
                            <Form.Label>
                              Title <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="title"
                              placeholder="Enter title"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.title}
                            />
                            {formik.touched.title && formik.errors.title ? (
                              <span
                                className={formik.errors.title ? `` : `d-none`}
                              >
                                <label className="pl-1 text-danger">
                                  {formik.errors.title}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>
                          <Form.Group
                            className="mb-3"
                            controlId="formBasicTitle"
                          >
                            <Form.Label>
                              Short Description{" "}
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="shortDescription"
                              placeholder="Enter short description"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.shortDescription}
                            />
                            {formik.touched.shortDescription &&
                            formik.errors.shortDescription ? (
                              <span
                                className={
                                  formik.errors.shortDescription ? `` : `d-none`
                                }
                              >
                                <label className="pl-1 text-danger">
                                  {formik.errors.shortDescription}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>
                          <Form.Group
                            className="mb-3"
                            controlId="formBasicEmail"
                          >
                            <Form.Label>
                              Description <span className="text-danger">*</span>
                            </Form.Label>
                            <CKEditor
                              editor={ClassicEditor}
                              data={
                                formik.values.description
                                  ? formik.values.description
                                  : ""
                              }
                              content={
                                formik.values.description
                                  ? formik.values.description
                                  : ""
                              }
                              onChange={(event, editor) =>
                                onEditorChange(
                                  event,
                                  editor,
                                  formik.setFieldValue
                                )
                              }
                            />
                            {formik.touched.description &&
                            formik.errors.description ? (
                              <span
                                className={
                                  formik.errors.description ? `` : `d-none`
                                }
                              >
                                <label className="pl-1 text-danger">
                                  {formik.errors.description}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>
                          <Form.Group
                            controlId="formFilePreview"
                            className="mb-3"
                          >
                            {getFile ? (
                              <img
                                src={getFile}
                                alt="not found"
                                width="200"
                                height="200"
                              />
                            ) : null}
                          </Form.Group>
                          <Form.Group
                            controlId="formFile"
                            className="mb-3"
                            onChange={(e) =>
                              handlePreviewImage(e, formik.setFieldValue)
                            }
                          >
                            <Form.Label>
                              Upload Image{" "}
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="file"
                              name="photo"
                              accept=".png,.jpg,.jpeg,.webp"
                            />
                           
                            {formik.touched.photo && formik.errors.photo ? (
                              <span
                                className={formik.errors.photo ? `` : `d-none`}
                              >
                                <label className="pl-1 text-danger">
                                  {formik.errors.photo}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>

                          <Form.Group
                            className="mb-3"
                            controlId="formBasicpartnerDiscountType"
                          >
                            <Form.Label>Partner Discount </Form.Label>

                            <Form.Control
                              as="select"
                              name="partnerDiscountType"
                              onChange={(e) =>
                                formik.setFieldValue(
                                  "partnerDiscountType",
                                  e.target.value
                                )
                              }
                            >
                              <option value="">Select partner discount</option>
                              {partnerDiscountData &&
                              partnerDiscountData.length > 0
                                ? partnerDiscountData.map((d, k) => {
                                    return (
                                      <option
                                        key={d._id}
                                        value={d._id}
                                        className="text-capitalize"
                                      >
                                        {d.title}
                                      </option>
                                    );
                                  })
                                : null}
                            </Form.Control>
                          </Form.Group>
                          <Form.Group
                            className="mb-3"
                            controlId="formBasicPrice"
                          >
                            <Form.Label>
                              Price <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="price"
                              placeholder="Enter price"
                              onBlur={formik.handleBlur}
                              onChange={(e) => formik.handleChange(e)}
                            />
                            {formik.touched.price && formik.errors.price ? (
                              <span
                                className={formik.errors.price ? `` : `d-none`}
                              >
                                <label className="pl-1 text-danger">
                                  {formik.errors.price}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>
                          <Form.Group
                            className="mb-3"
                            controlId="formBasicEmail"
                          >
                            <Form.Label>
                              Discount on Price
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="discount"
                              placeholder="Enter discount price"
                              onBlur={formik.handleBlur}
                              onChange={(e) => formik.handleChange(e)}
                            />
                            {formik.touched.discount &&
                            formik.errors.discount ? (
                              <span
                                className={
                                  formik.errors.discount ? `` : `d-none`
                                }
                              >
                                <label className="pl-1 text-danger">
                                  {formik.errors.discount}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>
                          <Form.Group
                            className="mb-3"
                            controlId="formBasicEmail"
                          >
                            <Form.Label>
                              Min Age for Consultation (Years)
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="number"
                              name="minAge"
                              placeholder="Enter min age"
                              onBlur={formik.handleBlur}
                              onChange={(e) => formik.handleChange(e)}
                            />
                            {formik.touched.minAge && formik.errors.minAge ? (
                              <span
                                className={formik.errors.minAge ? `` : `d-none`}
                              >
                                <label className="pl-1 text-danger">
                                  {formik.errors.minAge}
                                </label>
                              </span>
                            ) : null}
                          </Form.Group>
                          <Row>
                            <Col md={1}>
                              <label className="label-font">Status</label>
                            </Col>
                            <Col
                              md={11}
                              className="check-inline d-flex mt-3 flex-column"
                            >
                              <label className="right-label-radio mr-3 mb-2">
                                Active
                                <input
                                  name="status"
                                  className="status"
                                  checked={formik.values.status}
                                  value={formik.values.status}
                                  type="radio"
                                  onChange={(e) =>
                                    formik.setFieldValue("status", true)
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>

                              <label className="right-label-radio mr-3 mb-2">
                                Inactive
                                <input
                                  name="status1"
                                  className="status"
                                  checked={!formik.values.status}
                                  value={!formik.values.status}
                                  type="radio"
                                  onChange={(e) =>
                                    formik.setFieldValue("status", false)
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                            </Col>
                          </Row>
                         
                          <Button className="btn-filled" type="submit">
                            Submit
                          </Button>
                        </Form>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default AddPrescriptionRefill;
